<template>
  <div>
    <basic-notice-detail v-if="!isLaunchpack"></basic-notice-detail>

    <launchpack-notice-reg v-if="isLaunchpack"></launchpack-notice-reg>
  </div>
</template>

<script>
  import BasicNoticeDetail from "./BasicNoticeDetail";
  import LaunchpackNoticeReg from "./LaunchpackNoticeReg";

  export default {
    components: {
      LaunchpackNoticeReg,
      BasicNoticeDetail
    },
    created() {

    },
    data() {
      return {}
    },
    methods: {

    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main';

</style>
